import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PzCardComponent } from './pz-card.component';

@NgModule({
    imports: [CommonModule],
    exports: [PzCardComponent],
    declarations: [PzCardComponent],
})
export class PzCardModule {
}
